import { render, staticRenderFns } from "./SalaryVariants.vue?vue&type=template&id=24abd4b8&"
import script from "./SalaryVariants.vue?vue&type=script&lang=js&"
export * from "./SalaryVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports